import Vue from 'vue';
import App from './App.vue';
import router from './router';
import http from './http';
import store from './store';
import Loading from 'vue-loading-overlay';
import i18n from "./i18n";

import VueApexCharts from 'vue-apexcharts';

import 'vue-loading-overlay/dist/vue-loading.css';
import modelStateErrors from './mixins/modelStateErrors';
import userAuthentication from './mixins/userAuthentication';
import AOS from 'aos'
import 'aos/dist/aos.css'
import Moment from 'vue-moment';
import VueCurrencyInput from 'vue-currency-input';
import VueHtml2Canvas from 'vue-html2canvas';

Vue.config.productionTip = false;

Vue.prototype.$http = http;

Vue.mixin(userAuthentication);
Vue.mixin(modelStateErrors);
Vue.use(Moment);
Vue.component('loading', Loading);
Vue.use(VueCurrencyInput);
Vue.use(VueHtml2Canvas);

Vue.use(VueApexCharts);
Vue.component('apexcharts', VueApexCharts);

let restorePromise = null;
let api_restore = null;
if (userAuthentication.methods.userLoggedIn()) {
  // if(userAuthentication.methods.userHasRole('Apprentice')) api_restore = 'apprentice/restore';
  // else api_restore = 'jobseeker/restore'
  restorePromise = store.dispatch('account/restore')
    .catch(res => userAuthentication.methods.clearToken());
} else {
  restorePromise = Promise.resolve();
}

restorePromise.then((res) => {
  // Start the application.
  new Vue({
    created() {
      AOS.init()
    },
    store,
    router,
    i18n,
    render: h => h(App),
  }).$mount('#app');
});
